import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Flex } from 'reflexbox';

import { Popover, Modal, Sidebar, Subheading, Paragraph } from '@treams/treams-ui';
import { EvaluationFormFragment } from 'generated/graphql';

import {
	SelectConversationTypeItem as Item,
	SelectConversationTypeCard as InfoCard,
	SelectConversationTypeCardNoSelection as NoSelection,
} from '.';

type Props = {
	visible: boolean;
	forms: EvaluationFormFragment[];
	selected?: EvaluationFormFragment | undefined;
	onClose: () => void;
	onSave: (form: EvaluationFormFragment) => void;
};

export const SelectConversationTypeModal = ({
	selected,
	visible,
	forms,
	onClose,
	onSave,
}: Props) => {
	const { t } = useTranslation('', {
		keyPrefix: 'evaluations.create.modal.form.selectConversationType.modal',
	});

	const selectionButtons = forms.map((form) => (
		<Item key={form.id} form={form} onClick={onSave} selected={selected} />
	));

	const handleSave = () => {
		if (selected) {
			onSave(selected);
			onClose();
		}
	};

	return (
		<Popover backdrop center visible={visible}>
			<Modal width="1000px">
				<Modal.Header title={t('header')} />
				<Modal.Contents p={0}>
					<StyledFlex>
						<StyledSideBar p={1} pt={0}>
							<Subheading p={2} pt={4}>
								<Paragraph>{t('sidebar.title')}</Paragraph>
							</Subheading>
							{selectionButtons}
						</StyledSideBar>
						{selected ? <InfoCard {...selected} /> : <NoSelection />}
					</StyledFlex>
				</Modal.Contents>
				<Modal.FormFooter onCancel={onClose} onSave={handleSave} saveTitle={t('footer.save')} />
			</Modal>
		</Popover>
	);
};

const StyledFlex = styled(Flex)`
	min-height: 100%;
	scrollbar-gutter: stable;
`;

const StyledSideBar = styled(Sidebar)`
	height: auto;
	width: 25%;
	border-right: 1px solid ${({ theme }) => theme.colors.lightBlue};
`;
